import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=65d544b1&scoped=true&"
import script from "./CollapseItem.vue?vue&type=script&lang=ts&"
export * from "./CollapseItem.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseItem.vue?vue&type=style&index=0&id=65d544b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d544b1",
  null
  
)

export default component.exports